import React, { useState } from 'react'

import { ConfirmModal, Fieldset, RadioButton, useModalContext } from '@fourthwall/components'

export type SyncFulfillmentsType = 'SYNC_NEW' | 'SYNC_ALL'

export type SyncFulfillmentsModalProps = {
  onConfirm: (syncType: SyncFulfillmentsType) => void
}

export const SyncFulfillmentsModal = ({ onConfirm }: SyncFulfillmentsModalProps) => {
  const { close } = useModalContext()
  const [syncType, setSyncType] = useState<SyncFulfillmentsType>('SYNC_NEW')

  const handleConfirm = () => {
    onConfirm(syncType)
  }

  return (
    <ConfirmModal
      title="Which orders do you want to sync?"
      text={
        <div style={{ marginTop: 4 }}>
          <Fieldset>
            <Fieldset.Row>
              <RadioButton
                value={syncType}
                label="Sync only new orders"
                checkedValue="SYNC_NEW"
                onChange={() => setSyncType('SYNC_NEW')}
              />
            </Fieldset.Row>
            <Fieldset.Row>
              <RadioButton
                value={syncType}
                label="Sync all orders, including current unfulfilled orders"
                checkedValue="SYNC_ALL"
                onChange={() => setSyncType('SYNC_ALL')}
              />
            </Fieldset.Row>
          </Fieldset>
        </div>
      }
      onConfirm={handleConfirm}
      close={close}
    />
  )
}
